// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Zelda Universe - Warp Gates Configuration
 * 
 * Ancient portals connecting Hyrule to other dimensions.
 */

export const warpGates = [
  {
    id: 'gate_zelda_to_marioworld',
    name: 'Mushroom Portal',
    type: 'warpgate',
    description: 'An ancient portal adorned with mushroom symbols. It hums with power-up energy.',
    distance: 28, // Distance from Hyrule Kingdom
    destinationUniverse: 'marioworld',
    destinationGate: 'gate_marioworld_to_zelda',
    toSystem: 1000, // Mushroom Kingdom
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'ANCIENT PORTAL',
    services: [],
    primaryColor: '#FF0000',
    secondaryColor: '#00FF00',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_zelda_to_sonicuniverse',
    name: 'Chaos Emerald Portal',
    type: 'warpgate',
    description: 'Chaos Emerald Portal - A gateway powered by chaos energy. Triforce meets Chaos Emeralds.',
    distance: 26, // Distance from Hyrule Kingdom
    destinationUniverse: 'sonicuniverse',
    destinationGate: 'gate_sonicuniverse_to_zelda',
    toSystem: 2000, // Green Hill Zone
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'CHAOS ENERGY PORTAL',
    services: [],
    primaryColor: '#228B22',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_zelda_to_discworld',
    name: 'Narrative Portal',
    type: 'warpgate',
    description: 'A gateway where magic meets narrative causality. Legend meets satire.',
    distance: 30, // Distance from Hyrule Kingdom (system 1200)
    destinationUniverse: 'discworld',
    destinationGate: 'gate_discworld_to_zelda',
    toSystem: 500, // Discworld start system
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'ANCIENT PORTAL',
    services: [],
    primaryColor: '#228B22',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true
  }
];

// Warp gate positions for map visualization
export const warpGatePositions = {
  'gate_zelda_to_marioworld': { x: 50, y: 55, z: 5 },   // 28 LY from Hyrule Kingdom
  'gate_zelda_to_sonicuniverse': { x: 40, y: 55, z: 5 }, // 26 LY from Hyrule Kingdom
  'gate_zelda_to_discworld': { x: 35, y: 45, z: 5 }     // 30 LY from Hyrule Kingdom
};